
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './BabyPhotoContest.css';
import * as actions from './Actions';
import { fetchInitialData } from "../fetchData";
import Right from '../right/Right';
import Service from '../service/Service';
import MoreContest from './common/MoreContest';
import withLocation from "../../withLocation";
const service = new Service();

class BabyPhotoContest extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        let initialData = [];
        let winnersContest = [];
        let count;
        let record = "yes";
        var dataAry =[];
        let imageUrl='';
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            initialData = window.__initialData__['initialData'];
            delete window.__initialData__;

        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                initialData = props.staticContext.initialData['initialData'];
                imageUrl=props.staticContext.initialData['initialData']['result'].length > 0 && props.staticContext.initialData['initialData']['result'][0]['banners'][0]['bannerUrl'];
            }
        }
        this.state = {
            initialData: initialData,
            count: 2,
            record : record,
            dataAry: dataAry,
            imageUrl:imageUrl,
            metaTitle: "Cute Baby & Kids Photo Contest, Quizzes & more - FirstCry Parenting",
            metaDescription: "Participate in the FirstCry Parenting baby and kids photo contests, quizzes and more to stand a chance to win exciting prizes.",
            myaccountURl: '/my-account?URL=' + global.currentURL,
            checkGardian : false,
            winnerCountFlag : 0
        }
        this.qnaPageNo = 1;
        this.totalCount = this.state.initialData.length;
        if (props.params.page && props.params.page > 0) {
            this.qnaPageNo = parseInt(props.params.page);
        }
        this.maxScroll = 0;
        this.timeout = 0;
        // alert('inside constructor');
    }
    static initialAction(reqUrl, ftk, authData, uId, childData) {    
            // alert('init'); 
        var header = {
            'Content-Type': 'application/json',
            'ftk':  ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var url = global.api_url + "contest/getactivecontestdetails";
        let body = JSON.stringify({ 
                    "pageNo": 1,
                    "pageSize": 10        
                })
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        // console.log('initila data', this.state.initialData);
        if (global.ftk && ((global.userAry['Sex'] == "" || global.userAry['Sex'] == null) && global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].length >=1)) {
            this.setState({ checkGardian: true });
        }else{
           this.setState({checkGardian: false});
        }
        if(this.state.initialData.result != 'Record Not Found'){
            let inData = this.state.initialData.result; 
            this.setState({ initialData: [] });
            this.setState({initialData: inData});
        }
        if(navigator.onLine) {
            this.setState({ windowWidth: window.outerWidth});
            let contUrl = this.props.location.pathname.split('/');
            if(contUrl[2]){
                if(contUrl[2] == 'expired'){
                    this.pastContestAPICall();
                }else if(contUrl[2] == 'winners'){
                    this.winnersAPICall();
                }else if(contUrl[2] == 'active'){
                    if (!this.state.initialData || (this.state.initialData.result && this.state.initialData.result.length < 1)) {
                        service.showLoader();
                        this.activeContestlanding();
                        this.getBannerAPICall();
                    } else {
                        localStorage.setItem('activeContest', JSON.stringify(this.state.initialData));
                        this.activeContestlanding();
                    }
                }else{
                    if (!this.state.initialData || (this.state.initialData.result && this.state.initialData.result.length < 1)) {
                        service.showLoader();
                        this.activeContestlanding();
                        this.getBannerAPICall();
                    } else {
                        localStorage.setItem('activeContest', JSON.stringify(this.state.initialData.result));
                        this.activeContestlanding();
                        this.getBannerAPICall();
                    }
                }
            }
            
            document.addEventListener("click", this.domClick);
            // window.addEventListener('scroll', this.pageDataScroll) 
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        }
        console.log('active this.state.initialData', this.state.initialData)
        this.totalCount = this.state.initialData.result.length;
        console.log(' ---- ', this.totalCount);
        this.pageData = this.pageData.bind(this);
        window.addEventListener("scroll", this.pageData, false);
    }
    // pagination code start=====================
    pageData() {
        // debugger;
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            // debugger;
            if (document.getElementsByClassName('data-container')[0]) {
                var cS = document.getElementsByClassName('data-container')[0].offsetTop;
                var cH = document.getElementsByClassName('data-container')[0].offsetHeight - 200,
                    wS = window.scrollY - cS;
                    var checkVal = (window.innerHeight + window.scrollY) >= document.body.offsetHeight;
                if (!(checkVal) && wS > cH) {
                    if (wS > _this.maxScroll && _this.totalCount >= (_this.qnaPageNo * 10)) {
                        _this.maxScroll = wS;
                        ++_this.qnaPageNo;
                        service.showLoader();
                        document.getElementById('pgNo').value = _this.qnaPageNo;
                        _this.LoadAllTypesContestOnScroll(_this.qnaPageNo, 10);
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
    }

    LoadAllTypesContestOnScroll(pageno, size) {
        var hostUrl = window.location.pathname;        
            if (hostUrl.includes("/expired")){
                // var url = global.api_url + "contest/getpastcontestdetails";
                var url = global.api_ci_url + "MemoriesContest/getpastcontestdetails";
                var postData = {
                    "pageno": pageno,
                    "pagesize": size
                }
            }else{
                // var url = global.api_url + "contest/getactivecontestdetails";
                var url = global.api_ci_url + "MemoriesContest/getactivecontestdetails";
                var postData = {
                    "pageno": pageno,
                    "pagesize": size
                }
            }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == 1) {
                console.log('API result: ', json['result']);
                if(json['result'].length > 0){
                    this.setState({record : 'yes'})
                }else{
                    this.setState({record : 'No'})
                }
                if (hostUrl.includes("/expired")){
                    if (this.state.initialData.length > 0) {
                        if (size == (pageno * 10)) {
                            this.setState({ initialData: json['result']});
                        } else {
                            let ary = this.state.initialData;
                            this.setState({ initialData: ary.concat(json['result'])});
                            this.totalCount = this.state.initialData.length;
                            console.log('pageno : '+ pageno +' totalCount '+ this.totalCount )
                            console.log('Data: ',this.state.initialData)
                        }
                    }
                }
                else{
                    if (this.state.initialData.length > 0) {
                        if (size == (pageno * 10)) {
                            this.setState({ initialData: json['result']});
                        } else {
                            let ary = this.state.initialData;
                            this.setState({ initialData: ary.concat(json['result'])});
                            this.totalCount = this.state.initialData.length;
                            console.log('pageno : '+ pageno +' totalCount '+ this.totalCount )
                            console.log('Data: ',this.state.initialData)
                        }
                    }
                }
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
        });
    }
    // paginatoin code end ======================
    componentWillUnmount() {
        window.removeEventListener("scroll", this.pageData, false);
        document.removeEventListener("click", this.domClick);
    }
    pageDataScroll = () => {
        if (window.matchMedia('(max-width: 767px)').matches) {
            let checkScrollVal = 54;
            if (window.pageYOffset > checkScrollVal) {
                document.querySelector('.mob-landing').classList.add('sticky_tracker_heading');
            } else {
                document.querySelector('.mob-landing').classList.remove('sticky_tracker_heading');
            }
        }
    }

    getBannerAPICall(){
        if (navigator.onLine){
            var postData = {
                "moduleId": 3 
            }
            var url = global.api_ci_url + "MemoriesContest/getdfpbannerdata";
            // var url = global.api_url + "config/getdfpbannerdata";
            service.postServiceCall(url, postData).then((json) => {
                if (json['result']) {
                    // console.log("Banners data: ", json['result'])
                    this.setState({ getbanner: json['result'] }, () => { service.loadImages(); });
                }
                
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        }
    }

    activeContestlanding() {
        if(navigator.onLine){
            if(this.state.initialData.result != 'Record Not Found'){
                let aData = this.state.initialData.result;
                this.setState({ initialData: [] });
                this.setState({ initialData: aData });
                console.log('Active Contest Data: ', this.state.initialData)
            }
            this.addRemoveClass('contests-tab');
            this.addRemoveClass('active');
            let contUrl = this.props.location.pathname.split('/');
            if(contUrl[2] == 'active'){
                this.setState({ metaTitle: "Live / On-going Baby & Kids Contests - FirstCry Parenting" });
            }
                    
            try {
                if(this.state.initialData && this.state.initialData.length > 0){
                    this.totalCount = this.state.initialData.result.length;
                    console.log('Active this.totalCount ',this.totalCount)
                    this.setState({ noRecords: 1 });
                }else{
                    this.setState({ noRecords: 0 });
                }

                if (Object.keys(this.state.initialData).length > 0) {
                    service.loadImages();
                    this.loadReadMore();
                }
                service.hideLoader();
            } catch (error) {
                console.error(error);
                service.hideLoader();
            }
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        }

    }

    selectPastContest(event){
        if(navigator.onLine) {
            if(event == 'active'){
                document.getElementsByClassName('active-contest')[0].style.display = 'block';
                document.getElementsByClassName('past-contest')[0].style.display = 'none'; 
                this.activeContestlanding();
            }
            if(event == 'past'){
                document.getElementsByClassName('active-contest')[0].style.display = 'none';
                document.getElementsByClassName('past-contest')[0].style.display = 'block';        
            } 
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        }       
    }

    pastContestAPICall(){
        if(navigator.onLine) {
            this.setState({ metaTitle: "Expired Contests - FirstCry Parenting" });
            this.addRemoveClass('expired');

            document.getElementsByClassName('active-contest')[0].style.display = 'none';
            document.getElementsByClassName('past-contest')[0].style.display = 'block';
            var postData = {
                "pageno": 1,
                "pagesize": 10  
            }
            // var url = global.api_url + "contest/getpastcontestdetails";
            var url = global.api_ci_url + "MemoriesContest/getpastcontestdetails";
            service.postServiceCall(url, postData).then((json) => {
                if (json['result']) {
                    // console.log("Past conets data: ", json['result']);
                    this.totalCount = json['result'].length;
                    console.log('past this.totalCount ',this.totalCount)
                    this.setState({ initialData: json['result'] }, () => { service.loadImages(); });
                    localStorage.setItem('pastContest', JSON.stringify(this.state.initialData)); 

                    this.loadReadMore();
                }  
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        } 
    }

    winnersAPICall(){
        if(navigator.onLine) {
            this.addRemoveClass('winners-tab');
            this.setState({ metaTitle: "Winner List: FirstCry Parenting Baby & Kids Contests" });
            var winnersData;        
            document.getElementsByClassName('contests-tab-section')[0].style.display = 'none';
            document.getElementsByClassName('winners-cnt')[0].style.display = 'block';
            var postData = {
                "pageNo": 1,
                "pageSize": 10  
            }
            // var url = global.api_url + "contest/getwinnerstab";
            var url = global.api_ci_url + "MemoriesContest/getwinnerstab";
            service.postServiceCall(url, postData)
            .then((json) => {
              let result = json;
              console.log("Winners data response: ", json);
            
              this.setState({ winnersData: result['result'] || [] }, () => {
                console.log("🏆 Winners data set in state:", this.state.winnersData);

                service.loadImages();

                console.log("📊 Checking winnersData array length (after state update):", this.state.winnersData.length);

                if (this.state.winnersData.length === 0) {
                    console.warn("⚠️ winnersData is empty!");
                }

                for (let i = 0; i < this.state.winnersData.length; i++) {
                  const item = this.state.winnersData[i];
                  console.log(`🔹 Loop index: ${i}`);
                  console.log("📦 Current winnersData item:", item);

                  if (item.winners && item.winners.length > 0) {
                    console.log(`🏆 Winners found for index ${i}:`, item.winners);

                    this.setState({ winnerCountFlag: 1 }, () => {
                      console.log("✅ winnerCountFlag set to 1");
                    });

                    console.log("🚀 Calling loadSliders()...");
                    this.loadSliders();
                  } else {
                    console.log(`⚠️ No winners found for index ${i}`);
                    this.setState({ winnerCountFlag: 0 }, () => {
                      console.log("❌ winnerCountFlag set to 0");
                    });
                  }
                }

                // Save after state update is complete
                localStorage.setItem('winnersData', JSON.stringify(this.state.winnersData));
              });
               })
               .catch((error) => {
                 console.error("❌ Error in postServiceCall:", error);
                 service.loadImages();
               });

        }else{
            service.showAlert("Please Check Internet Connection!!!");
        } 
    }

    selectContestTab(){
        if(navigator.onLine) {
            document.getElementsByClassName('winners-cnt')[0].style.display = 'none';
            document.getElementsByClassName('contests-tab-section')[0].style.display = 'block';
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        } 
    }
    addRemoveClass(act){
        if(navigator.onLine) {
            this.setState({ selContest: "active"});
            if(act == 'winners-tab'){
                if (document.getElementById("contests-tab").classList.contains("active-tab")) {
                    document.getElementById("contests-tab").classList.remove("active-tab");
                    document.getElementById('winners-tab').classList.add('active-tab');
                    document.getElementById('contests-tab').classList.remove("tab-arrow");
                    document.querySelectorAll('.memoriesContest-cnt #winners-tab .tab-arrow')[0].style.display = "block";
                    document.querySelectorAll('.memoriesContest-cnt #contests-tab .tab-arrow')[0].style.display = "none"; 
                } 
            }
            if(act == 'contests-tab'){
                if (document.getElementById('winners-tab').classList.contains('active-tab')) {
                    document.getElementById('winners-tab').classList.remove('active-tab');
                    document.getElementById('contests-tab').classList.add('active-tab');
                    document.querySelectorAll('.memoriesContest-cnt #winners-tab .tab-arrow')[0].style.display = "none";
                    document.querySelectorAll('.memoriesContest-cnt #contests-tab .tab-arrow')[0].style.display = "block";
                } 
            }
            if(act == 'expired'){
                if (document.getElementById("dev_active").classList.contains("isChecked")) {
                    this.setState({ selContest: "expired"});
                    document.getElementById("dev_active").classList.remove("isChecked");
                    document.getElementById('dev_past').classList.add('isChecked');
                    document.getElementById('active').classList.remove('isChecked');
                    document.getElementById('expired').classList.add('isChecked');
                } 
            }
            if(act == 'active'){
                if (document.getElementById("dev_past").classList.contains("isChecked")) {
                    this.setState({ selContest: "active"});
                    document.getElementById("dev_past").classList.remove("isChecked");
                    document.getElementById('dev_active').classList.add('isChecked');
                    document.getElementById('expired').classList.remove('isChecked');
                    document.getElementById('active').classList.add('isChecked');
                } 
            }
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        } 
        
    }

    loadReadMore() {
        let readmoreAry = document.getElementsByClassName('more');
        for (let i = 0; i < readmoreAry.length; i++) {
            let maxHeight = 40;
            let dataId = readmoreAry[i].getAttribute('data-id');
            let divHeight = document.getElementById(dataId).offsetHeight;
            if (divHeight > maxHeight) {
                document.getElementById(dataId).style.height = maxHeight + 'px';
                readmoreAry[i].style.overflow = "hidden";
                readmoreAry[i].nextSibling.innerHTML = '<span className="R14_link">Read more </span>';
            }
        }
    }

    loadSliders() {
        let slider = document.querySelectorAll(".slider");
        for (let i = 0; i < slider.length; i++) {
            let margin = 20;
            let extraWidth = 10;
            let cnt = slider[i].getAttribute("data-count");
            if(cnt > 4){
                cnt = 4;
            }
            if (slider[i].getElementsByClassName('slide')[0]) {
                let sliderulwidth = cnt * slider[i].getElementsByClassName('slide')[0].offsetWidth;
                let marginbetweenimages = cnt  * margin;
                slider[i].style.width = (sliderulwidth + marginbetweenimages) + "px";
            }
            if (slider[i].offsetWidth < document.getElementsByClassName("sub-container")[0].offsetWidth) {
                if (slider[i].nextSibling) {
                    slider[i].nextSibling.remove();
                }
            }
        }
    }


    domClick(event) {
        if (!event.target.classList.contains('share-ic') && !event.target.classList.contains('whtap-icon') && !event.target.classList.contains('left')) {            
            if (document.getElementsByClassName('sharing-options')[0]) {
                document.getElementsByClassName('sharing-options')[0].style.display = 'none';
            }
        }
        
        if (event.target.classList.contains('next')) {
            if (document.getElementsByClassName('next')[0]) {
                document.getElementsByClassName('next')[0].style.display = 'none';
            }else{
                document.getElementsByClassName('next')[0].style.display = 'block'; 
            }
        }        
    }
   
    shareArticle(articleurl, shareoption, image, title) {
        if(navigator.onLine) {
            this.setState({ metaurl: articleurl });
            this.setState({ metaimg: image });
            this.setState({ metatitle: title });

            var shareurl;
            // if (!articleurl.includes('http')) {
            //     articleurl = 'https:' + articleurl;
            // }
            let ary = document.getElementsByClassName('sharing-options');
            for (let i = 0; i < ary.length; i++) {
                ary[i].style.display = 'none';
            }
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'none';
            }
            if (shareoption == "facebook") {
                shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
            } else if (shareoption == "twitter") {
                shareurl = 'https://twitter.com/share?url=';
            } else if (shareoption == "pintrest") {
                shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
            } else if (shareoption == "whatsapp") {
                shareurl = 'whatsapp://send?text=';
            }
            var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
            if (sharewindow.focus) {
                sharewindow.focus();
            }
            return false;
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        }
    }
    closeThankYouPopup= (event)=>{
        const thankyouPopup = document.getElementById("quiz_thankyou_overlay");
        thankyouPopup.style.display = "none";
        document.getElementsByTagName('html')[0].style.overflow = 'visible';
    }
    render() {
        console.log("this.state.winnersData =====>",this.state.winnersData) 
        console.log("this.state.winnerCountFlag =========>",this.state.winnerCountFlag)
        return (
            <main className="main-container">
                <Helmet
                    title={this.state.metaTitle}
                    description={this.state.metaDescription}
                    // meta={[
                    //         // <!-- Google / Search Engine Tags -->
                    //         { "itemprop": "name", "content": "PARENTING.FIRSTCRY.COM" },
                    //         { "itemprop": "description", "content":  this.state.metaDescription },
                    //         { "itemprop": "image", "content": this.state.imageUrl },
                    //         { "itemprop": "description", "content": this.state.metaDescription },
                    //         // <!-- Facebook Meta Tags -->
                    //         { "property": "og:url", "content": global.redirect_url },
                    //         { "property": "og:type", "content": "website" },
                    //         { "property": "og:title", "content": "PARENTING.FIRSTCRY.COM" },
                    //         { "property": "og:description", "content":  this.state.metaDescription },
                    //         { "property": "og:image", "content": this.state.imageUrl },
                            
                    //         // <!-- Twitter Meta Tags -->
                    //         { "name": "twitter:card", "content": "summary_large_image" },
                    //         { "name": "twitter:title", "content": "PARENTING.FIRSTCRY.COM" },
                    //         { "name": "twitter:description", "content":  this.state.metaDescription },
                    //         { "name": "twitter:image", "content": this.state.imageUrl }
                    //     ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a className="R11_9e" href="/">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Baby & Kids Photo Contests</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Baby & Kids Photo Contests </h1>
                </div>
                <div className="sub-container memoriesContest-cnt left">
                    <div className="data-container left">
                        <div className="container_bump">
                            <div className="mob-landing">
                                <a onClick={() => actions.networkCheck()} href={this.state.checkGardian ? service.getRedirectUrl(this.state.myaccountURl) : "/baby-photo-contest"} title="contests">
                                    <div className="mob-tabs active-tab M14_9e" id="contests-tab" value="">
                                        <div id="dev_contests-tab">CONTESTS</div>
                                        <div className="tab-arrow"></div>
                                    </div>
                                </a>
                                <a onClick={() => actions.networkCheck()} href={this.state.checkGardian ? service.getRedirectUrl(this.state.myaccountURl) : "/baby-photo-contest/winners"} title="winners">
                                    <div className="mob-tabs M14_9e" id="winners-tab" value="">
                                        <div id="dev_winners-tab">WINNERS</div>
                                        <div className="tab-arrow"></div>
                                    </div>
                                </a>
                            </div>
                            {/* banner start */}
                                { this.state.getbanner && this.state.getbanner.length > 1 ?
                                    <div className="slideshow" id="FirstCarousel">
                                        <div className="slides-row sliding-items">
                                          {this.state.getbanner &&
                                            this.state.getbanner.map((row, index) => (
                                              <a key={index} href={row.redirectUrl} target={row.target == 1 ? '_blank' : '_self'}>
                                                <img
                                                  src={row.imageUrl.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")}
                                                  onError={(e) => (e.target.src = row.imageUrl.replace("http://", "https://"))}
                                                  style={{ height: row.height + 'px', width: row.width + 'px' }}
                                                />
                                              </a>
                                            ))}
                                        </div>

                                        <nav className="slide-controls">
                                            <a role="button" className="slide-arrow arrow-prev" title="Previous slide"><span className="icon" data-icon-font="g"></span></a>
                                            <a role="button" className="slide-arrow arrow-next" title="Next slide"><span className="icon" data-icon-font="h"></span></a>
                                        </nav>
                                    </div>
                                        
                                :null
                                }

                                { this.state.getbanner && this.state.getbanner.length == 1 ?
                                    <div id="banner-slider">
                                    {this.state.getbanner &&
                                      this.state.getbanner.map((row, index) => (
                                        <a 
                                          key={index} 
                                          className="banner-img" 
                                          href={row.redirectUrl} 
                                          target={row.target == 1 ? '_blank' : '_self'} 
                                          rel={row.target == 1 ? 'noopener noreferrer' : undefined}
                                        >
                                          <img
                                            src={row.imageUrl.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")}
                                            onError={(e) => (e.target.src = row.imageUrl.replace("http://", "https://"))}
                                            className="devTopbannerimg"
                                            id="WeeklyContest"
                                            style={{ height: row.height + 'px', width: row.width + 'px' }}
                                            loading="lazy"
                                            alt=""
                                          />
                                        </a>
                                      ))}
                                  </div>
                                  
                                : null
                                }
                            {/* banner end */}
                            {/* winner tab start */}
                            <div className="winners-cnt" id="winnertabsection">
                                {this.state.winnersData && this.state.winnersData.length > 0 && this.state.winnersData.map((result, index) =>
                                <div className="contests contest1">
                                    <div className="contest-title M18_42" key = {index}>{result.title}</div>
                                    <div className="parenting-slider2 tmp_5"> 
                                     {this.state.winnerCountFlag == 1 ?  
                                        <div className={`parentUL parentUL_${result.contestId}`}>                
                                            <ul className="slider temp5 fl" data-count={result.winners.length} style={{ width: '1090px' }}>

                                            {result.winners && result.winners.length > 0 && result.winners.slice(0, 3).map((winners, index) =>
                                                <li className="slide template5 fl">
                                                    <a className="contest_images" onClick={() => service.gardianProfileChk()} href={this.state.checkGardian ? service.getRedirectUrl(this.state.myaccountURl) : `/memories/photodetails/${winners.id}`} target="_blank" title={winners.userName} key = {winners.index}>
                                                        <img src={winners.image_url.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")} data-src={winners.image_url.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")} onError={(e) => (e.target.src = winners.image_url.replace("http://", "https://"))} className="dsblk" title="Bottom Wear"  alt="Bottom Wear"  id={result.title}/>
                                                    </a>
                                                    <div id="winner-nm" className="winner-name M14_42">{winners.userName}</div>
                                                    <div className="prize-won R14_75">{winners.prize}</div>
                                                    <div className="winnertag">
                                                         <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/contest-winner-icon.svg'} alt="winner" title="winner"/> 
                                                    </div>
                                                </li>
                                            )}
                                            { result.winners && result.winners.length > 3 ?
                                                (<li className="allbtn-slide slide template5 fl">
                                                    <a href={this.state.checkGardian ? service.getRedirectUrl(this.state.myaccountURl) :`/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/winners/${result.contestId}`} className="viewallwinners" id={result.title} data-id={result.contestId} data-title={result.title} data-result={actions.formatArticleDate(result.createdDate)} onClick={() => actions.networkCheck()}>
                                                        <div className="arrow_container">
                                                            <span className="all-icon viewallwinnersicon"  id={result.title} data-icon-font="&"></span>
                                                        </div>
                                                        <span className="R14_pink viewallwinnerstxt" id={result.title}>View All Winners</span>
                                                    </a>
                                                </li>) 
                                                :
                                                ''
                                            }                 
                                            </ul>
                                            { (result.winners && result.winners.length > 3) &&
                                            <div className="arrows">                    
                                                <span className={`next next_${result.contestId}`} onClick={(e) => { actions.slideStage(e, this, result.contestId) }}>
                                                    <span data-icon-font="h" className="icon"></span>
                                                </span>                    
                                                <span className={`prev prev_${result.contestId}`} style={{display:'none'}} onClick={(e) => { actions.slideStage(e, this, result.contestId) }}>
                                                    <span data-icon-font="g" className="icon"></span>
                                                </span>                      
                                            </div>
                                            }
                                        </div>
                                        : 
                                            <div className="no_winner">
                                                <span className="M14_42">
                                                winners are yet to announce as the contest are going on. To participate in the contest, kindly click on “view contest”
                                                </span>
                                            </div>
                                        }  
                                    </div> 
                                </div>
                                )}                
                            </div>
                            {/* winner tab end */}

                            {/* contest tab start */}
                            <div className="contests-tab contests-tab-section" id="contests-tab-section" ref={this.myRef}>
                                {/* <input type="hidden" id="page_no" name="page_no" value="2"/> */}
                                <input type="hidden" id="page_no" name="page_no" value={this.state.count}/>
                                <div className="sortBy_overlay" style={{display:'none'}} onClick={() => actions.closeContestPopup()}>
                                    <div className="sort_by_popup">
                                        <span className="M18_42">Sort By</span>
                                        <a className="srt" href="/baby-photo-contest/expired">
                                            <div className="sort-contest devpastcontestpopup" onClick={() => this.selectPastContest('past')}>
                                                <span className="R15_42 left contest-txt" id="dev_past">Past Contest</span>
                                                { this.state.selContest == "expired" ? 
                                                    <span id="expired" data-icon-font='#' className="right icon isChecked"></span>
                                                    :
                                                    <span id="expired" data-icon-font='"' className="right icon"></span>
                                                }
                                            </div>
                                        </a>
                                        <a className="srt isChecked" href="/baby-photo-contest/active">
                                            <div className="sort-contest devactivecontestpopup" onClick={() => this.selectPastContest('active')}>
                                                <span className="contest-txt R15_42 left isChecked" id="dev_active">Active Contest</span> 
                                                { this.state.selContest == "expired" ? 
                                                     <span id="active" data-icon-font='"' className="right icon"></span>
                                                    :
                                                    <span id="active" data-icon-font='#' className="right icon isChecked"></span>
                                                }
                                                {/* <span id="active" data-icon-font='#' className="right icon isChecked" ></span> */}
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                
                                {/* active contests */}
                                <div className="active-contest" id="active-contest" >
                                    <p className="cont-heading" onClick={() => actions.contestPopup(this)}>
                                        <span className="M17_42" id="sortby_actxt">Active Contest</span>
                                        <span data-icon-font="j" className="icon" id="sortby_acicon"></span>
                                    </p>
                                    <p className="coming">Coming Soon</p>
                                    <div id="active-contest-res" >

                                    {this.state.initialData && this.state.initialData.length > 0 && this.state.initialData.map((result, index) =>
                                        <div key ={index}> 
                                            <div className="contesttype" data-status={result.isActive == 1 ? "Active" : "closed"} data-type={result.contest_type} id={result.contestId}>
                                                <div className="image_cont left" data-id ={result.title}>
                                                    <a href={this.state.checkGardian ? service.getRedirectUrl(this.state.myaccountURl) :`/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/${result.contestId}`} id={result.contestId} onClick={() => actions.networkCheck()}>
                                                        {result.showMsg ?
                                                        <div className="hurry-up">
                                                            <span className=""> {result.showMsg.length > 20 ? result.showMsg.substring(0,20): result.showMsg}</span>
                                                        </div>
                                                        : ''}
                                                        <div className="contest-img" key = {result.contestId}>

                                                            <img src={result.banners[0].bannerUrl.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")} onError={(e) => (e.target.src = result.banners[0].bannerUrl.replace("http://", "https://"))} className="devactimg" id={result.contestId} title="Contest Image"  alt="Contest Image"/> 
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="contest-text right">
                                                    <div className="contest-share mob-share right" onClick={() => actions.shareOn(result.contestId)}>
                                                        <span className="share-ic fb-icon left">
                                                            <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook-icon.png'} 
                                                            alt="Facebook" title="Facebook"/>
                                                           
                                                        </span>
                                                        <span data-icon-font="" className="share-ic whtap-icon left"></span>
                                                        <span className="M13_61 left">Share</span>
                                                    </div>
                                                    <a href={this.state.checkGardian ? service.getRedirectUrl(this.state.myaccountURl) :`/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/${result.contestId}`} id={result.contestId} key = {result.contestId} onClick={() => actions.networkCheck()}>
                                                        <span className="title M18_42" id={`cont-ttl_${result.contestId}`}>{result.title}</span>

                                                        {result.isActive == 1 ? <div className="inprogress R13_green" id={result.contestId}><span className="dot"></span>In Progress</div> : <div className="closed R13_red" id={result.contestId}><span className="dot dotgrey"></span>Closed</div>} 
                                                        
                                                        <span className="contest-descp R14_61 more"  id={`cont-descp_${result.contestId}`} data-id={`cont-descp_${result.contestId}`}> {result.description} </span>

                                                        <div className="read R14_link"></div>
                            
                                                        <div className="cont-period" id={result.contestId}>
                                                            <span className="period-text fl R15_9e" id={result.contestId}>Contest Period:</span>
                                                            <span id={`cont-date_${result.contestId}`} className="fl M14_42"> {actions.formatArticleDate(result.startDate)} - {actions.formatArticleDate(result.endDate)}</span>
                                                        </div>

                                                        <div className="result-date"  id={result.contestId}>
                                                            <span className="results fl R15_9e" id={result.contestId}>Result Date:</span>
                                                            <span id={`result-dt_${result.contestId}`} className="M14_42 devresdate">{actions.formatArticleDate(result.resultDate)}</span>
                                                        </div> 
                                                    </a>

                                                    {/* { global.ftk == '' ?     */}
                                                    <div className="landing-btn devuploadphoto left" id={result.contestId} onClick={() => actions.goToFeature(result.contest_type, result.contestId)}>
                                                        {result.contest_type == "Memories Contest" || result.contest_type == "Face a day" || result.contest_type == "My Bumpie" || result.contest_type == "Memories Contest" ?
                                                        <span data-icon-font="&#xe000;" className="icon devuploadphoto" id={result.contestId}></span>
                                                        : ''}
                                                        { 
                                                            result.contest_type == "Milestone Contest" || result.contest_type == "Face a day" || result.contest_type == "My Bumpie" || result.contest_type == "Memories Contest" 
                                                            ?
                                                            <span className="M14_white devuploadphoto" id={result.contestId} >UPLOAD NOW</span> 
                                                            : 
                                                            result.contest_type == "Discussion" || result.contest_type == "Read" ? <span className="M14_white devuploadphoto" id={result.contestId} >PARTICIPATE NOW</span>
                                                            :
                                                            result.contest_type == "Q and A" ? <span className="M14_white devuploadphoto" id={result.contestId} >ASK NOW</span>
                                                            :
                                                            result.contest_type == "Vaccination" || result.contest_type == "Baby Teething Tool" ? <span className="M14_white devuploadphoto" id={result.contestId} >UPDATE TRACKER</span>
                                                            :
                                                            result.contest_type == "Groups" ? <span className="M14_white devuploadphoto" id={result.contestId} >UPDATE TRACKER</span>
                                                            :
                                                            <span className="M14_white devuploadphoto" id={result.contestId} >PARTICIPATE NOW</span> 
                                                        }
                                                    </div>
                                                    
                                                    { result.isShowLeaderboard == 1 ?
                                                    <a href={this.state.checkGardian ? service.getRedirectUrl(this.state.myaccountURl) :`/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/${result.isWinnerbased == 1 ? 'leaderboard' : 'entries'}/${result.contestId}`} className="leaderboardbtn landing-btn cont-btns left" id={result.contestId} onClick={() => actions.networkCheck()}>
                                                    <span className="M14_white" id={result.contestId} >
                                                    {result.isWinnerbased == 1 ? 'VIEW LEADERBOARD' : 'VIEW ENTRIES'}
                                                    </span>
                                                    </a>
                                                     :''
                                                    } 

                                                    <div className="view-det" id={`share_${result.contestId}`}>                     
                                                        <a href={this.state.checkGardian ? service.getRedirectUrl(this.state.myaccountURl) :`/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/${result.contestId}`} className="R14_link view_details" id={`rules_${result.contestId}`} target="_blank" onClick={() => actions.networkCheck()}>
                                                        View More Details
                                                        </a>
                                                        <div className="contest-share right" onClick={() => actions.shareOn(result.contestId)}>
                                                            <span className="share-ic fb-icon left">
                                                                <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook-icon.png'}
                                                                alt="Facebook" title="Facebook" />
                                                            </span>
                                                            <span data-icon-font="" className="share-ic whtap-icon left"></span>
                                                            <span className="M13_61 left">Share</span>
                                                        </div>
                                                        <div className={`sharing-options sharingOpt${result.contestId}`}>
                                                            <ul className="left">
                                                            <li 
                                                              className="whatsapp-share left"
                                                                onClick={() => {
                                                                  actions.shareArticle(
                                                                    global.redirect_url +
                                                                      'baby-photo-contest/contest/' +
                                                                      actions.loadcontestName(result.title) +
                                                                      '/' +
                                                                      result.contestId,
                                                                    'whatsapp',
                                                                    result.banners[0].bannerUrl
                                                                  );
                                                                  actions.loadcontestName(result.title);
                                                              }}
                                                            >
                                                              <span className="M16_61 social-share" id="whatsapp">
                                                                <img
                                                                  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png"
                                                                  className="fetusfacebookimg"
                                                                  alt="Whatsapp Icon" title="Whatsapp Icon"
                                                                />
                                                              </span>
                                                            </li>
                                                                
                                                                <li className="facebook-share left" onClick={() => actions.shareArticle(global.redirect_url+'baby-photo-contest/contest/'+actions.loadcontestName(result.title)+'/'+result.contestId, 'facebook', result.banners[0].bannerUrl,actions.loadcontestName(result.title))}>
                                                                <span className="M16_61 social-share" id="facebook">
                                                                    <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png'}className="facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                                                                </span>
                                                                </li>
                                                                <li className="twitter-share left" onClick={() => actions.shareArticle(global.redirect_url+'baby-photo-contest/contest/'+actions.loadcontestName(result.title)+'/'+result.contestId, 'twitter', result.banners[0].bannerUrl,actions.loadcontestName(result.title))}>
                                                                <span className="M16_61 social-share" id="twitter">
                                                                    <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png'} className="twitterimg"alt="Twitter Icon" title="Twitter Icon" />
                                                                </span>
                                                                </li>
                                                                <li className="twitter-share left" onClick={() => actions.shareArticle(global.redirect_url+'baby-photo-contest/contest/'+actions.loadcontestName(result.title)+'/'+result.contestId, 'pintrest', result.banners[0].bannerUrl,actions.loadcontestName(result.title))}>
                                                                <span className="M16_61 social-share" id="pintrest">
                                                                    <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png'} className= "pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                                                                </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>                     
                                                </div>
                                            </div>
                                            {/* <MoreContest eleRef={this} leatherDetails={this.state.MoreleatherDetails} currentPage={this.state.count} record = {this.state.record}/> */}

                                            <MoreContest eleRef={this} MoreleatherDetails={this.state.initialData} />
                                            <input type="hidden" id="pgNo" value="" />
                                        </div>
                                        )}
                                        
                                        {this.state.noRecords == 1 ? <div className="no_record"> </div> : <span></span>}
                                    </div>
                                </div>
                                {/* active contests end */}

                                {/* past contests  */}
                                <div className="past-contest" id="past-contest" style={{ display: 'none' }}>
                                    <p className="cont-heading" onClick={() => actions.contestPopup(this)}>
                                        <span className="M17_42" id="sortby_pctxt">Past Contest</span>
                                        <span data-icon-font="j" id="sortby_pcicon" className="icon"></span>
                                    </p>
                                    <div id="past-contest-res">
                                    {this.state.initialData && this.state.initialData.length > 0 && this.state.initialData.map((result, index) =>
                                        <div>
                                            <div className="contesttype" data-status={result.isActive == 1 ? "Active" : "closed"} data-type={result.contest_type} id={result.contestId}>
                                                <div className="image_cont left">
                                                    <a href={this.state.checkGardian ? service.getRedirectUrl(this.state.myaccountURl) :`/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/${result.contestId}`} id={result.contestId} onClick={() => actions.networkCheck()}>
                                                        <div className="contest-img">
                                                            
                                                            <img src={result.banners[0].bannerUrl.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")} onError={(e) => (e.target.src = result.banners[0].bannerUrl.replace("http://", "https://"))} className="devpastimg" id={result.contestId}/>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="contest-text right">
                                                    <div className="contest-share mob-share right" onClick={() => actions.shareOn(result.contestId)}>
                                                        <span className="share-ic fb-icon left">
                                                            <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook-icon.png'}
                                                            alt="Facebook" title="Facebook" />
                                                        </span>
                                                        <span data-icon-font="" className="share-ic whtap-icon left"></span>
                                                        <span className="M13_61 left">Share</span>
                                                    </div>
                                                    <a href={this.state.checkGardian ? service.getRedirectUrl(this.state.myaccountURl) : `/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/${result.contestId}`} onClick={() => actions.networkCheck()}>
                                                        <span className="title M18_42" id={`cont-ttl_${result.contestId}`}>{result.title}</span>

                                                        {result.isActive == 1 ? <div className="inprogress R13_green" id={result.contestId}><span className="dot"></span>In Progress</div> : <div className="closed R13_red" id={result.contestId}>Closed</div>}
                                
                                                        <p className="contest-descp R14_61 more" id={`cont-descp_${result.contestId}`} data-id={`cont-descp_${result.contestId}`}>{result.description} </p>

                                                        <div className="read R14_link"></div>
                                
                                                        <div className="cont-period" id={result.contestId}>
                                                            <span className="period-text fl R15_9e" id={result.contestId}>Contest Period :</span>
                                                            <span id={`cont-date_${result.contestId}`} className="fl M14_42">{actions.formatArticleDate(result.startDate)} - {actions.formatArticleDate(result.endDate)}</span>
                                                        </div>
                                                        <div className="result-date" id={result.contestId}>
                                                            <span className="results fl R15_9e" id={result.contestId}>Result Date :</span>
                                                            <span id={`result-dt_${result.contestId}`} className="M14_42 devresdate">{actions.formatArticleDate(result.resultDate)}</span>
                                                        </div>
                                                    </a>
                                                    {new Date(result.resultDate) < new Date() && (
                                                    <a href={this.state.checkGardian ? service.getRedirectUrl(this.state.myaccountURl) :`/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/winners/${result.contestId}`} className="landing-btn viewactive left" id="view-winners" onClick={() => actions.networkCheck()}>
                                                        <span className="M14_white view-winners" id={result.contestId}>VIEW WINNERS</span>
                                                    </a>
                                                    )}
                                                    {/* { result.isShowLeaderboard == 1 ?
                                                    <a href={this.state.checkGardian ? service.getRedirectUrl(this.state.myaccountURl) :`/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/leaderboard/${result.contestId}`} className="leaderboardbtn landing-btn cont-btns left" id={result.contestId} onClick={() => actions.networkCheck()}>
                                                     <span className="M14_white" id={result.contestId} >{result.leaderbordText}</span>
                                                     </a>
                                                     : ''
                                                    } */}
                                                    { result.isShowLeaderboard == 1 ?
                                                    <a href={this.state.checkGardian ? service.getRedirectUrl(this.state.myaccountURl) :`/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/${result.isWinnerbased == 1 ? 'leaderboard' : 'entries'}/${result.contestId}`} className="leaderboardbtn landing-btn cont-btns left" id={result.contestId} onClick={() => actions.networkCheck()}>
                                                    <span className="M14_white" id={result.contestId} >
                                                    {result.isWinnerbased == 1 ? 'VIEW LEADERBOARD' : 'VIEW ENTRIES'}
                                                    </span>
                                                    </a>
                                                     : ''
                                                    }
                                                    

                                                    <div className="view-det" id={`share_${result.contestId}`}>
                                                        <a href={this.state.checkGardian ? service.getRedirectUrl(this.state.myaccountURl) :`/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/${result.contestId}`} className="R14_link view_details" id= {`rules_${result.contestId}`} target="_blank" onClick={() => actions.networkCheck()}>View More Details</a>

                                                        <div className="contest-share right" onClick={() => actions.shareOn(result.contestId)}>
                                                            <span className="share-ic fb-icon left">
                                                                <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook-icon.png'}
                                                                alt="Facebook" title="Facebook" />
                                                            </span>
                                                            <span data-icon-font="" className="share-ic whtap-icon left"></span>
                                                            <span className="M13_61 left">Share</span>
                                                        </div>
                                                        <div className="sharing-options">
                                                            <ul className="left">
                                                                <li className="whatsapp-share left" 
                                                                 onClick={() => actions.shareArticle(global.redirect_url+'/baby-photo-contest/contest/'+actions.loadcontestName(result.title)+'/'+result.contestId, 'whatsapp', result.banners[0].bannerUrl,actions.loadcontestName(result.title))}>
                                                                <span className="M16_61 social-share" id="whatsapp">
                                                                    <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png'} className="fetusfacebookimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                                                                </span>
                                                                </li>
                                                                <li className="facebook-share left" onClick={() => actions.shareArticle(global.redirect_url+'/baby-photo-contest/contest/'+actions.loadcontestName(result.title)+'/'+result.contestId, 'facebook', result.banners[0].bannerUrl,actions.loadcontestName(result.title))}>
                                                                <span className="M16_61 social-share" id="facebook">
                                                                    <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png'}className="facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                                                                </span>
                                                                </li>
                                                                <li className="twitter-share left" onClick={() => actions.shareArticle(global.redirect_url+'/baby-photo-contest/contest/'+actions.loadcontestName(result.title)+'/'+result.contestId, 'twitter', result.banners[0].bannerUrl,actions.loadcontestName(result.title))}>
                                                                <span className="M16_61 social-share" id="twitter">
                                                                    <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png'} className="twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                                                                </span>
                                                                </li>
                                                                <li className="twitter-share left" onClick={() => actions.shareArticle(global.redirect_url+'/baby-photo-contest/contest/'+actions.loadcontestName(result.title)+'/'+result.contestId, 'pintrest', result.banners[0].bannerUrl,actions.loadcontestName(result.title))}>
                                                                <span className="M16_61 social-share" id="pintrest">
                                                                    <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png'} className= "pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                                                                </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {/* <MoreContest eleRef={this} leatherDetails={this.state.MoreleatherDetails} currentPage={this.state.count} record = {this.state.record}/> */}
                                            <MoreContest eleRef={this} MoreleatherDetails={this.state.initialData} />
                                            <input type="hidden" id="pgNo" value="" />
                                        </div>
                                    )}
                                    </div>
                                    
                                </div>
                                {/* past contests end */}

                                <div className="loader-overlay">          
                                    <div className="loader-img">
                                        <img src="//parenting.firstcry.com/vaccination/images/ajax-loader-tr.svg" alt="Loader Icon" title="Loader Icon" />
                                    </div>
                                </div>
                            </div>
                            {/* contest tab end */}
                        </div>
                    </div>
                </div>
                <div className="sortby-popup" id="sortby-popup" style={{ display: 'none' }}>
                    <div className="sortby">
                        <div>Sort by</div>
                        <div className="sort-contest">
                            <span>Past Contest</span>
                            <input type="radio" name="rdbtn" value="past"/>
                        </div>
                        <div className="sort-contest">
                            <span>Active Contest</span>
                            <input type="radio" name="rdbtn" value="active"/>
                        </div>
                    </div>
                </div>
                <Right url={this.props.location.pathname} />
                <div className="quiz_thank_you_overlay" id="quiz_thankyou_overlay" style={{ display: 'none' }}>
                    <div className="quiz_thank_you_pop">
                        <div className="close_btn_wrap">
                            <div className="close_btn" onClick={this.closeThankYouPopup} data-icon-font="C"></div>
                        </div>
                        <div className="quiz_pop_body">
                            <div className="pop_content_wrap">Thank You for participating in this quiz. You may also be interested in this contest</div>
                            <div className="pop_img_wrap">
                                <a href="#">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/memoryimages/quiz-landing-page-final_03-1748614876306.jpg" alt="contest" title="contest"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        )
    }
}

export default withLocation(BabyPhotoContest);
